import { borderosRoutes } from './borderos/rotas';
import { motAutorizadorRoutes } from './mot/rotas';

const routes = {
    path: 'autorizadorfinanceiro',
    name: 'Autorizador_Financeiro',
    component: () => import('./AutorizadorView.vue'),
    metas: {
        rules: [...borderosRoutes.meta.rules, ...motAutorizadorRoutes.meta.rules],
    },
    children: [borderosRoutes, motAutorizadorRoutes],
};

export default routes;
